import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import MotionAppear from '../../Components/MotionAppear';
import { textStyle } from '../Main/constants';
import { EditableTypography } from '../../Components/EditableTypography';
import EditableImage from '../../Components/EditableImage';

export default function About() {
    const tablet = useMediaQuery("(max-width:1000px)");

    return (
        <Box sx={{ display: 'flex', flexDirection: tablet ? 'column' : 'row', alignItems: tablet ? 'center' : 'flex-start', alignContent: tablet ? 'center' : 'flex-start' }}>

            <MotionAppear>
                <EditableImage alt={`foto majitelky`} fireKey={'img_about'} sx={{ width: '300px', height: '300px', objectFit: 'cover', borderRadius: '50%' }} />
            </MotionAppear>

            <EditableTypography fireKey={'about_text'} sx={{ ...textStyle, ml: tablet ? '0px' : { md: '25px', lg: '60px', xl: '60px' }, mt: tablet ? '60px' : '0px' }} />
        </Box>
    )
}
